import { render, staticRenderFns } from "./NatureUnitInfo.vue?vue&type=template&id=07328407&scoped=true&"
import script from "./NatureUnitInfo.vue?vue&type=script&lang=js&"
export * from "./NatureUnitInfo.vue?vue&type=script&lang=js&"
import style0 from "./NatureUnitInfo.vue?vue&type=style&index=0&id=07328407&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07328407",
  null
  
)

export default component.exports